import React, { useState, useRef, useEffect } from 'react';
import './style.scss';
import TextInput from '../textInput';

const FilterDropdown = ({ data, ProSelected, isSearching }) => {
    const [showDropdown, setShowDropdown] = useState(true);
    const [filterText, setFilterText] = useState('');
    const [SelectedUsers, setSelectedUsers] = useState([]);
    const dropdownRef = useRef(null);
    useEffect(() => {

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };
    const handleFilterChange = (e) => {
        isSearching(true);
        setFilterText(e.target.value);
        setShowDropdown(true);
    };

    function getPro(user) {
        let users = [...SelectedUsers];
        let tempUserID = JSON.stringify(user.split(',')[1], null, 2).split('"')[1].split('"')[0];
        let fullName = JSON.stringify(user.split(',')[0], null, 2).split('"')[1].split('"')[0];

        users.push(tempUserID);
        users = [...new Set(users)];
        ProSelected(tempUserID);
        setShowDropdown(false);
        setFilterText(String(fullName).trim());
    };

    const filteredData = data.filter((item) => {
        if (item === null || item === undefined || item === '') {
            return 0
        } else {
            let itemtxt = item.split(',')[0];
            return String(itemtxt ?? '').toLowerCase().includes(String(filterText ?? '').toLowerCase())
        };
    });

    return (
        <div className='filter-Parenet'>
            <div className="dropdown" ref={dropdownRef}>

                <div className="dropdown-content show">
                    <TextInput style={{ width: '95%', marginLeft: '4%', fontSize: '14px' }} type="text" placeholder="Search.." id="myInput" value={filterText} onChange={handleFilterChange} />
                    {showDropdown && filteredData.map((user, index) => {
                        let isSelected = user.split(',')[1] === SelectedUsers.find(item => item === user.split(',')[1]);
                        return (
                            <a
                                style={{ background: isSelected ? 'var(--purple)' : '', borderRadius: "10px", fontSize: "13px", marginBottom: '1%', width: '82%', marginLeft: '2%' }}
                                key={index} href={`#${user.split(',')[0]}`}
                                onClick={() => getPro(user)}
                            >
                                {user.split(',')[0]}
                            </a>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default FilterDropdown;
